<template>
  <div class="item-list">
    <div class="information-icon">
      <img
        :src="
          dataList.userIcon ? dataList.userIcon : '/static/img/mr-usericon.png'
        "
        alt=""
      />
      <i v-if="dataList.readFlag == 0"></i>
    </div>
    <div class="information-info">
      <div class="information-title">
        <span
          class="info-name"
          @click="detail(dataList.targetId, dataList.targetType,dataList.id)"
          >{{ dataList.title }}</span
        >
        <!-- <span class="info-db">评论了你的文章</span>
        <span class="info-title">《参观正在美术馆：既长知识又凉爽》</span> -->
      </div>
      <div
        v-if="likeno"
        class="information-content"
        v-html="dataList.content"
      ></div>
      <div class="information-date">{{ dataList.createTime }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hotPost",
  props: ["dataList", "likeno"],
  data() {
    return {};
  },
  methods: {
    detail(targetId, targetType,id) {
      this.$api.readMessage({
        id: id
      }).then((res) => {
        this.$router.push("/detail/" + targetId + "/" + targetType);
      });
    },
  },
};
</script>

<style scoped lang="scss">
.item-list {
  width: 100%;
  // min-height: 120px;
  display: flex;
  padding: 20px 0;
  border-bottom: 1px solid #efefef;
  .information-icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    position: relative;
    img {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      position: absolute;
    }
    i {
      width: 10px;
      height: 10px;
      background: #f1403c;
      border: 1px solid #ffffff;
      border-radius: 50%;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .information-info {
    width: 634px;
    margin-left: 10px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    .information-title {
      .info-name {
        font-size: 16px;
        font-weight: 600;
        color: #121212;
        cursor: pointer;
      }
      .info-db {
        font-size: 15px;
        color: #666666;
      }
      .info-title {
        font-size: 15px;
        color: #317DFF;
      }
    }
    .information-content {
      font-size: 15px;
      color: #121212;
      line-height: 24px;
      margin: 5px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      display: -moz-box;
      -moz-line-clamp: 2;
      -moz-box-orient: vertical;
      word-wrap: break-word;
      word-break: break-all;
      white-space: normal;
    }
    .information-date {
      font-size: 13px;
      font-weight: 400;
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/InformationList.vue